import CONFIG from "config/config";

export const isProduction = () => CONFIG.ENV === "prod";
export const isLocal = () => CONFIG.ENV === "dev";
